import React from 'react'
import { Button } from 'antd'
import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import { getMessage } from '../../util/IntlMessages'

function PageHeader({ pageTitle, match, history, createProfilePath }) {
  return (
    <div className="default-header-div">
      <div className="default-header-breadcrumb">
        <CustomBreadcrumb match={match} history={history} />
        <Button
          className="default-header-button"
          type="primary"
          onClick={() => {
            history.push({ pathname: createProfilePath })
          }}
        >
          {getMessage(pageTitle)}
        </Button>
      </div>
    </div>
  )
}

export default PageHeader
